import React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

interface InfoIconProps {
  width?: number;
  height?: number;
  color?: string;
  strokeWidth?: number;
}

const InfoIcon: React.FC<InfoIconProps> = ({
  width = 24,
  height = 24,
  color = '#4F9EB5',
  strokeWidth = 1.5,
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M12 17V11"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <Circle
        cx="1"
        cy="1"
        r="0.5"
        transform="matrix(1 0 0 -1 11 9)"
        fill={color}
        stroke={color}
      />
      <Path
        d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default InfoIcon;
